/**
 * VUEshop
 * ============================================================================
 * * 版权所有 2015-2027 深圳搜豹网络科技有限公司，并保留所有权利。
 * 网站地址: http://www.vueshop.com.cn
 * ----------------------------------------------------------------------------
 * 这不是一个自由软件！您只能在不用于商业目的的前提下对程序代码进行修改和使用 .
 * 不允许对程序代码以任何形式任何目的的再发布。
 * ============================================================================
 * $Author: soubao-java 2020-07-22 $
 */
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { setToken } from "@/utils/auth.js";
// import { getVerifyImage, getConfigs, getMenuList } from "@/utils/api";
import {
  getLogin,
  getUserInfo,
  getAgreementUrl,
  loginSupplier,
  getAdminDetail,
  getLeftMenus
} from "@/utils/api";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    reload: true,
    defaultActive: '1',
    currentOpenTabsMenuId: '1642',
    menuTabsList: [
      {
        menu_id: '1642',
        menu_name: "首页",
        path: "/home/system",
        type: '',
        index: '1'
      }
    ],
    menuScrollBarList: [],
    dropdownMenuList: [],
    indexTop: 0,
    goodsTop: 0,
    excludeName: [],
    userName: "",
    agreementStatus: "",
    agreementUrl: "",
    agreementAddUrl: "",
    userId: null,
    identity: "", //权限ID
    openFlag: false, //开源提示开关
    pcUrl: process.env.VUE_APP_PC_NAME,
    h5Url: process.env.VUE_APP_PC_NAME,
    menuList: [], //权限菜单列表
    CurrencyInfo: "", //货币信息
    getShowMenu: [], //平台显示的菜单
    jumpUrl: {},
    id: null,
    relId: null,
    FWS_PERIOD: [],
    mobile: "",
    choice:"",
    sub:{},
    // 新增：用于触发 submenu 收起所有子菜单（toggle）
    menuCloseAll: false,
  },
  getters: {
    excludeName: function (state) {
      return state.excludeName;
    },
  },
  mutations: {
    // 新增：切换 menuCloseAll，用于让 submenu 组件监听并调用 this.$refs.menu.closeAll()
    triggerMenuCloseAll(state) {
      state.menuCloseAll = !state.menuCloseAll;
    },
    clearVuexStorage(state, type = '') {
      // state.defaultActive = '1';
      // state.currentOpenTabsMenuId = '1642';
      // state.menuTabsList = [
      //   {
      //     menu_id: '1642',
      //     menu_name: "首页",
      //     path: "/home/system",
      //     type: '',
      //     index: '1'
      //   }
      // ];
      if (type == 'logout') {
        state.menuTabsList = state.menuTabsList.filter(x => x.menu_id == '1642');
        state.defaultActive = '1';
        state.currentOpenTabsMenuId = '1642';
      } else {
        state.menuTabsList = state.menuTabsList.filter(x => x.menu_id == '1642' || x.menu_id == state.currentOpenTabsMenuId);
      }
      state.dropdownMenuList = [];
    },
    setReload(state, is) {
      state.reload = is;
    },
    clearOtherTabs(state, id) {
      console.log(state.menuTabsList.filter(x => x.menu_id == id), '=====')
      state.menuTabsList = state.menuTabsList.filter(x => x.menu_id == id || x.menu_id == '1642');
      state.dropdownMenuList = [];
      // state.currentOpenTabsMenuId = id;
      console.log('3333', state)
    },
    clearAllTabs(state, arr) {
      state.menuTabsList = [{
        menu_id: '1642',
        menu_name: "首页",
        path: "/home/system",
        type: '',
        index: '1'
      }];
      state.dropdownMenuList = [];
      // state.currentOpenTabsMenuId = '1642';
    },
    removeMenuTabsList(state, id) {
      state.menuTabsList = state.menuTabsList.filter(x => x.menu_id != id);
      if (state.menuTabsList.length <= 6 && state.dropdownMenuList.length > 0) {
        state.menuTabsList.push(state.dropdownMenuList.shift());
      }
    },
    removeDropdownMenuList(state, id) {
      state.dropdownMenuList = state.dropdownMenuList.filter(x => x.menu_id != id);
    },
    setCurrentOpenTabsMenuId(state, id) {
      state.currentOpenTabsMenuId = id;
    },
    setDefaultActive(state, str) {
      state.defaultActive = str;
    },
    setMenuScrollBarList(state, arr) {
      state.menuScrollBarList = arr;
      state.menuScrollBarList.unshift({
        menu_id: '1642',
        parentId: '',
        parentIds: '',
        menu_name: "首页",
        menuIcon: "",
        path: "/home/system",
        type: '',
        menuComponent: "",
        menuPermission: "",
        menuType: "PAGE"
      })
      console.log('----2222', state.menuScrollBarList)
    },
    setMenuTabsList(state, obj) {
      let _is = state.menuTabsList.find(x => x.menu_id == obj.menu_id);
      if (!_is) {
        if (state.menuTabsList.length > 6) {
          console.log('====', state.dropdownMenuList.findIndex(x => x.menu_id == obj.menu_id))
          state.dropdownMenuList.unshift(state.menuTabsList.pop());
          if (state.dropdownMenuList.findIndex(x => x.menu_id == obj.menu_id) != -1) {
            state.dropdownMenuList = state.dropdownMenuList.filter(x => x.menu_id != obj.menu_id);
          }
        }
        state.menuTabsList.push(obj);
      }
    },
    setTabsSort(state, item) {
      state.dropdownMenuList = state.dropdownMenuList.filter(x => x.menu_id != item.menu_id);
      state.dropdownMenuList.unshift(state.menuTabsList.pop());
      state.menuTabsList.push(item);
    },
    setMobile(state, payload) {
      state.mobile = payload;
    },
    setChoice(state, payload) {
      state.choice = payload;
    },
    setSub(state, payload) {
      state.sub = payload;
    },

    $_setIndexTop(state, value) {
      state.indexTop = value;
    },

    $_setgoodsTop(state, value) {
      state.goodsTop = value;
    },
    setExcludeName(state, value) {
      state.excludeName = value;
    },
    /*更新开源开关*/
    updateOpenFlag(state, item) {
      state.openFlag = item;
    },

    setMenuList(state, item) {
      state.menuList = item;
    },

    /*更新货币信息*/
    updateCurrency(state, item) {
      state.CurrencyInfo = item;
    },
    /**获取登录用户名 */
    USER_NAME: (state, userName) => {
      state.userName = userName;
    },
    /**获取供应商协议 */
    AGREEMENT_STATUS: (state, agreementStatus) => {
      state.agreementStatus = agreementStatus;
    },
    AGREEMENT_URL: (state, agreementUrl) => {
      state.agreementUrl = agreementUrl;
    },
    AGREEMENT_ADD_URL: (state, agreementAddUrl) => {
      state.agreementAddUrl = agreementAddUrl;
    },
    /**获取登录用户id */
    USER_ID: (state, userId) => {
      state.userId = userId;
    },
    ID_ENTITY: (state, identity) => {
      state.identity = identity;
    },
    NEW_MENU: (state, menu) => {
      state.getShowMenu = menu;
    },
    GetJumpUrl: (state, url) => {
      state.jumpUrl = url;
    },
    GET_ID: (state, id) => {
      state.id = id;
    },
    GET_RELID: (state, id) => {
      state.relId = id;
    },
    GET_FWS_PERIOD: (state, arr) => {
      state.FWS_PERIOD = arr;
    }
  },
  actions: {
    setExcludeName({ commit }, value) {
      commit("setExcludeName", value);
    },
    // getCurrency(ctx, item) {
    //   getCurrency().then(res => {
    //     ctx.commit("updateCurrency", res)
    //   })
    // },

    /**
     * 用户登录
     */
    getLogin({ commit, dispatch, state }, userInfo) {
      console.log(dispatch)
      return new Promise((resolve, reject) => {
        getLogin(userInfo)
          .then((res) => {
            console.log('delu',res)
            if (res.status == 1) {
              let list = res.result;
              if (state.choice == 3) {
                commit("setMobile", userInfo.mobile);
              }
              localStorage.setItem('User-Single-Login-Verification-userToken',list.access_token)
              // const newPasswordDialogVisible = JSON.parse(localStorage.getItem('changePasFlag'));
              console.log('ds21321dada',list)
              localStorage.setItem('changePasFlag', list.changePasFlag ? list.changePasFlag : false);
              const newPasswordDialogVisible1 = JSON.parse(localStorage.getItem('changePasFlag'));
              console.log('wqwqqw',newPasswordDialogVisible1)
              setToken(list.access_token);
              commit('clearVuexStorage', 'logout')
              resolve();
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getSupplierLogin({ commit },value) {
      console.log(commit);
      return new Promise((resolve, reject) => {
        loginSupplier(value)
          .then((res) => {
            if (res.status == 1) {
              let list = JSON.parse(res.result.token);
              localStorage.setItem('User-Single-Login-Verification-userToken',list.access_token)
              setToken(list.access_token);
              resolve();
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    /**
     * 用户信息
     */
    getUserInfo({ commit }, identity) {
      console.log(identity);
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (res.status == 1) {
              commit("USER_NAME", res.result.nickname);
              commit("USER_ID", res.result.user_id);
              commit("ID_ENTITY", res.result.identity);
              commit("GET_ID", res.result.id);
              commit("GET_RELID", res.result.rel_id);
              if (res.result.start_time && res.result.end_time) {
                commit("GET_FWS_PERIOD", [res.result.start_time, res.result.end_time]);
              } else {
                commit("GET_FWS_PERIOD", []);
              }
              if (res.result.identity == 1 || res.result.identity == 3) {
                // 获取菜单列表
                getLeftMenus().then(res => {
                  console.log('菜单权限2====', res);
                  if (res.status == '1') {
                    let _arr = res.result;
                    _arr.forEach((x, index) => {
                      x.menu_id = x.menu_id.toString();
                      x.parent_id = x.parent_id.toString();
                      if (x.children_menus?.length) {
                        x.children_menus.forEach((y, index2) => {
                          y.menu_id = y.menu_id.toString();
                          y.parent_id = y.parent_id.toString();
                          y.location = `${index+2}-${index2+1}`;
                          y.path = x.path
                        })
                      }
                    })
                    commit("setMenuScrollBarList", _arr)
                  }
                })
              }
              resolve();
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * 供应商协议
     */
    getAgreementUrl({ commit }) {
      return new Promise((resolve, reject) => {
        getAgreementUrl()
          .then((res) => {
            if (res.result.agreement_status == 1) {
              commit("AGREEMENT_STATUS", res.result.agreement_status);
              commit("AGREEMENT_URL", res.result.agreement_url);
              commit("AGREEMENT_ADD_URL", res.result.agreement_add_url);
              
              resolve();
            } else {
              commit("AGREEMENT_STATUS", null);
              commit("AGREEMENT_URL", null);
              commit("AGREEMENT_ADD_URL", null);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * 供应商协议状态
     */
    // getAgreementStatus({ commit },value) {
    //   commit("AGREEMENT_STATUS", value);
    //   // return new Promise((resolve, reject) => {
    //   //   getAgreementUrl()
    //   //     .then((res) => {
    //   //       if (res.agreementStatus == 1) {
    //   //         commit("AGREEMENT_STATUS", res.agreementStatus);
    //   //         commit("AGREEMENT_URL", res.agreementUrl);
              
    //   //         resolve();
    //   //       } else {
    //   //         resolve(res);
    //   //       }
    //   //     })
    //   //     .catch((err) => {
    //   //       reject(err);
    //   //     });
    //   // });
    // },
    // /**
    //  * 供应商协议
    //  */
    // getAgreementUrl({ commit },value) {
    //   commit("AGREEMENT_URL", value);
    // },
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
    }),
  ],
});

export default store;
